
import BB_Elements from './elements'
import BB_Header from './header'
import BB_Responsive_Menu from './responsive-menu'
import BB_Cart from './cart'
import BB_Single_Product from './single_product'
import BB_Archive_Product from './archive_product'

class BB_Controller {
    constructor() {
        this.current_page_scripts()
    }
    global_scripts() {
        // topbar
        new BB_Responsive_Menu
        new BB_Header
        new BB_Elements
        
        new BB_Cart
    }
    static single( page ) {

    }
    get_current_page() {
        let body_element = document.querySelector('body')
        let body_classes = Array.from(body_element.classList)
        let current_page

        if ( body_classes.includes('home') ) current_page = 'home'
        else if ( body_classes.includes('single-product') ) current_page = 'single_product'
        else if ( body_classes.includes('tax-product_cat') || body_classes.includes('search-results') || body_classes.includes('woocommerce-shop') ) current_page = 'archive_product'
        else if ( body_classes.includes('page') ) current_page = 'default'
        
        return current_page;
    }
    current_page_scripts() {
        let current = this.get_current_page();

        this.global_scripts()

        switch (current) {
            case 'single_product':
                new BB_Single_Product()
                break;
            case 'archive_product':
                new BB_Archive_Product()
                break;
            default:
                break;
        }

    }
}

let init = new BB_Controller()

